import axios from "axios";
import { BASEURL } from "./configs/AppConfig";
import { getSession } from "./components/util-components/Session/Session";

const apiinstance = axios.create({
  baseURL: BASEURL,
  headers: {
    // Authorization: "Bearer " + getSession(),
    "Content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

apiinstance.interceptors.request.use(
  async (config) => {
    const accessToken = await getSession();
    config.headers["Authorization"] = "Bearer " + accessToken;
    return config;
  },
  async function (error) {
    Promise.reject(error);
  }
);
export default apiinstance;
